import { Component, OnDestroy, OnInit } from '@angular/core';
import { VesselDAO } from '../../../core/services/dao/vesselDAO';
import { Router } from '@angular/router';
import { ListYourBoatSessionService } from '../../../core/services/list-your-boat-session.service';
import { LoggingDAO } from '../../../core/services/dao/loggingDAO';

@Component({
  selector: 'app-boat-owner',
  templateUrl: './boat-owner.component.html',
  styleUrls: ['./boat-owner.component.scss'],
})
export class BoatOwnerComponent implements OnInit, OnDestroy {
  vessel: any = {};

  constructor(
    private vesselDao: VesselDAO,
    private router: Router,
    private listYourBoatSessionService: ListYourBoatSessionService,
    private loggingDAO: LoggingDAO,
  ) {}

  ngOnInit() {}

  submit() {
    this.vessel.anchorManaged = false;
    this.vessel.charterLOS = true;
    this.listYourBoatSessionService.vessel = this.vessel;

    this.logSaveAndContinueClick();
    this.router.navigate(['sign-up', 'become-a-boat-owner', 'vessels']);
  }

  ngOnDestroy(): void {}

  private logSaveAndContinueClick(): void {
    this.loggingDAO.serverTag({
      name: 'LYB - Save and Continue',
      className: this.constructor.name,
      description: 'Save and Continue click from the list your boat screen.',
      ancillary: {
        prospectiveVessel: {
          name: this.vessel.name,
          make: this.vessel.make,
          model: this.vessel.model,
          year: this.vessel.yearBuilt,
        },
      },
    });
  }
}
